export default "__VITE_ASSET__BByDTYfh__"